import React from 'react';
import { ProjectsStateProvider } from '@/components/providers/ProjectsStateProvider';
import ProjectsSection from './projects-section';

function ProjectsSectionWrapper() {
  return (
    <ProjectsStateProvider>
      <ProjectsSection />
    </ProjectsStateProvider>
  );
}

export default ProjectsSectionWrapper;
